// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3WBK1","footer":"ChangeClinic_footer__2cqUu"};